import { Injectable } from '@angular/core';

export const MSISDN_INPUT_WRAPPER_ID_PREFIX = 'msisdn-input-wrapper';

export const MSISDN_INPUT_ID_PREFIX = 'msisdn-input';

export interface MsisdnInputIds {
  inputId: string;
  wrapperId: string;
  controlUIDCounter: number;
}

@Injectable({ providedIn: 'root' })
export class MsisdnInputIdService {
  private controlUIDCounter = 0;

  public getMsisdnInputIds(): MsisdnInputIds {
    return {
      inputId: `${MSISDN_INPUT_ID_PREFIX}-${this.controlUIDCounter}`,
      wrapperId: `${MSISDN_INPUT_WRAPPER_ID_PREFIX}-${this.controlUIDCounter}`,
      controlUIDCounter: this.controlUIDCounter++,
    };
  }
}
